import { useAuth } from '../contexts/AuthContext';

export default function Account() {
  const { userData } = useAuth();

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold mb-6">My Account</h1>
      <div className="card">
        <h2 className="text-xl font-semibold mb-4">Profile Information</h2>
        <div className="space-y-3">
          <div>
            <span className="text-gray-600">Name:</span>
            <span className="ml-2 font-medium">{userData?.name}</span>
          </div>
          <div>
            <span className="text-gray-600">Email:</span>
            <span className="ml-2 font-medium">{userData?.email}</span>
          </div>
          <div>
            <span className="text-gray-600">Role:</span>
            <span className="ml-2 font-medium capitalize">{userData?.role}</span>
          </div>
        </div>
      </div>
    </div>
  );
}


